export default "__VITE_ASSET__Daxx9$m6__"